export const wearCycle = [
  { value: "express", label: "1 Week" },
  { value: "regular", label: "2 Week" },
];
